/* global newrelic */

import * as React from 'react';
import PropTypes from 'prop-types';

// components
import LocalSpinner from '../../shared/components/LocalSpinner';

class CheckoutComponentLoader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Component: null,
        };
    }
    componentDidMount() {
        this.props
            .importFunc()
            .then(({ default: Component }) => this.setState({ Component }))
            .catch(err => {
                // this catch is swallowing errors in dev env
                // eslint-disable-next-line no-console
                console.log('Error:', err);
                if (typeof newrelic !== 'undefined') {
                    newrelic.noticeError(err);
                }
                return null;
            });
    }
    render() {
        const { Component } = this.state;
        return Component ? (
            <Component {...this.props} />
        ) : (
            !this.props.hideLoader && <LocalSpinner fixedHeight={this.props.fixedHeightSpinner} />
        );
    }
}

CheckoutComponentLoader.propTypes = {
    importFunc: PropTypes.func.isRequired,
    hideLoader: PropTypes.bool,
    fixedHeightSpinner: PropTypes.bool,
};

CheckoutComponentLoader.defaultProps = {
    hideLoader: false,
};

export default CheckoutComponentLoader;
